<template>
  <component :is="layout" />
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import DefaultLayoutV3New from "@/layouts/DefaultLayoutV3New.vue";

@Component({
  components: {
    DefaultLayoutV3New
  }
})
export default class DefaultLayout extends Vue {
  get layout(): string {
    return "DefaultLayoutV3New";
  }
}
</script>
